export default {
      id: "i-bks-usage",
      viewBox: "0 0 32 32",
      url: __webpack_public_path__ + "img/sprite.svg#i-bks",
      toString: function () {
        return this.url;
      }
    }